import { useRef, useState } from 'react';
import { Column } from "../../../../core/components/Column";
import { Container } from "../../../../core/components/Container";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Delete } from '../../../../core/icons/Delete';
import { Likes } from "../../../match/domain/entities/userMatch";
import { AppDispatch } from "../../../../core/store/store";
import { useDispatch } from "react-redux";
import { Heart } from "../../../../core/icons/Heart";
import { XClose2 } from "../../../../core/icons/XClose";
import { deleteMyNotificationAction, updateMyNotificationReceived } from "../../../match/presentation/store/MatchSlice";
import InfoNotificationAdmin from "../../domain/entities/InfoNotificationAdmin";
import { formatDate } from "../../../../core/constants/constants";
import { ConfirmationModal } from "./ConfirmationModal";
import useMatch from "../../../match/presentation/hook/useMatch";
import { useHandleDeleteNotification } from "../hook/useHandleDeleteNotification";
import { ModalRestricted } from "../../../chat/presentation/components/ModalRestricted";
import ReactDOM from "react-dom";
import { updatedChatStatusReceived } from "../../../chat/presentation/store/ChatSlice";
import { sendUpdateChatStatus } from "../../../chat/presentation/store/ChatThunk";
import { Cancelled } from "../../../../core/icons/Cancelled";
import { ModalSimple } from "../../../../core/components/Modal";
import { WarningBG } from "../../../../core/icons/Warning";
import { History } from "../../../../core/icons/History";
import { onDeleteBlockMatch } from "../../../match/presentation/store/MatchThunk";
import { LinkifiedText } from "../../../../core/components/LinkifiedText";
import { RemoteImage } from "../../../../core/components/RemoteImage";

export const CardNotification: React.FC<
    {
        notification: Likes | InfoNotificationAdmin;
        showProfilePicture?: boolean;
        category: 'like' | 'match' | 'alert' | 'myLikes';
        showInfoProfile: (user_id: string) => void;
    }
> = ({ notification, showProfilePicture = true, category, showInfoProfile }) => {
    const [isSwiped, setIsSwiped] = useState(false);
    const [isLikedSwiped, setIsLikedSwiped] = useState(false);
    const [startX, setStartX] = useState(0);
    const [isMoving, setIsMoving] = useState(false);
    const startYRef = useRef(0);
    const touchSwipeLockedRef = useRef(false);
    const touchScrollLockedRef = useRef(false);
    const dispatch: AppDispatch = useDispatch();
    const [isClicked, setIsClicked] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isOpenWarning, setIsOpenWarning] = useState(false);
    const [actionNotFound, setActionNotFound] = useState(false);
    const [continueBlocked, setContinueBlocked] = useState(false);
    const [loading, setLoading] = useState(false);
    // const isBlock = u

    const handleStart = (clientX: number, clientY = 0) => {
        setStartX(clientX);
        setIsMoving(false);
        setIsClicked(true);
        startYRef.current = clientY;
        touchSwipeLockedRef.current = false;
        touchScrollLockedRef.current = false;
    };

    const handleMove = (clientX: number) => {
        const deltaX = startX - clientX;
        if (Math.abs(deltaX) > 10) {
            setIsMoving(true);
        }
        if (isMoving) {
            if (deltaX > 150) {
                setIsSwiped(true);
                setIsLikedSwiped(false);
            } else if (deltaX < -150 && (category === 'like' || (category === 'match' && (notification as Likes).status_user_id1 !== "blocked"))) {
                setIsLikedSwiped(true);
                setIsSwiped(false);
            } else {
                setIsSwiped(false);
                setIsLikedSwiped(false);
            }
        }
    };

    const handleEnd = () => {
        setIsMoving(false);
        setIsClicked(false);
        touchSwipeLockedRef.current = false;
        touchScrollLockedRef.current = false;
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        if (e.touches.length === 1) {
            handleStart(e.touches[0].clientX, e.touches[0].clientY);
        }
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        if (!isClicked || e.touches.length !== 1) return;

        const touch = e.touches[0];
        const deltaX = Math.abs(startX - touch.clientX);
        const deltaY = Math.abs(startYRef.current - touch.clientY);

        if (!touchSwipeLockedRef.current && !touchScrollLockedRef.current) {
            if (deltaY > 10 && deltaY > deltaX) {
                touchScrollLockedRef.current = true;
                handleEnd();
                return;
            }

            if (deltaX > 10 && deltaX > deltaY) {
                touchSwipeLockedRef.current = true;
            }
        }

        if (!touchSwipeLockedRef.current) return;

        handleMove(touch.clientX);
        if (e.cancelable) {
            e.preventDefault();
        }
    };

    const handleTouchEnd = () => {
        handleEnd();
    };

    const handleMouseDown = (e: React.MouseEvent) => {
        handleStart(e.clientX);
    };

    const handleMouseMove = (e: React.MouseEvent) => {
        if (isClicked) {
            handleMove(e.clientX);
        }
    };

    const handleMouseUp = () => {
        handleEnd();
    };
    const { handleLike } = useMatch();
    const handleDeleteAction = useHandleDeleteNotification();
    const handleDelete = () => {
        handleDeleteAction(category, notification); 
        setIsOpenWarning(false);
        setIsSwiped(false);
    };

    const handleLikeCard = () => {
        if (category === 'like') {
            handleLike(notification.user_id, "like");
            dispatch(deleteMyNotificationAction({ type: 'like', user_id: (notification as Likes).user_id }));
        }
        setIsOpenWarning(false);
        setIsLikedSwiped(false);
    };

    const handleBlockedCard = () => {
        const chatID = (notification as Likes).match_id;
        dispatch(sendUpdateChatStatus({
            params: {
                chat_id: chatID,
                status: "blocked",
            }
        }));
        dispatch(updatedChatStatusReceived({
            id: chatID,
            status_user_id1: "blocked",
            status_user_id2: (notification as Likes).status_user_id1,
        }));
        setIsOpenWarning(false);
        setIsLikedSwiped(false);
    };

    const toggleExpand = () => {
        setIsExpanded(prev => !prev);
    };

    const alertSubtitle = (notification as InfoNotificationAdmin).subtitle || "";
    const shouldShowExpand = alertSubtitle.length > 140 || alertSubtitle.includes("\n");

    const messages: { [key: string]: string } = {
        match: `You matched with `,
        like: `Liked you`,
        myLikes: `You liked `,
        alert: `${(notification as InfoNotificationAdmin).title}`,
    };

    const notificationMessage = () => {
        if (category in messages) {
            return (
                <>
                    {category === "alert" ? 
                    <>
                        {messages[category]}
                    </>
                    :
                    <>
                        {messages[category]} <span className="text-primary">{(notification as Likes).username}</span>
                    </>
                }
                </>
            );
        }
        return <span className="text-primary">{(notification as Likes).username}</span>;
    };

    const handleOpenWarning = () => {
        if (notification.status ===  "banned" || notification.status === "inactive"){
            setActionNotFound(true);
            return;
        }
        if (isLikedSwiped && category === "match"){
            setContinueBlocked(true);
            return;
        };
        setIsOpenWarning(true);
    }

    const handleSwipeAction = () => {
        if (isSwiped) {
            handleDelete();
        } else if (isLikedSwiped) {
            category === "match" ? handleBlockedCard() : handleLikeCard();
        }
    };

    const handleBlockMatch = async () => {
        if ((notification as Likes).status_user_id1 === "blocked") return;
        setLoading(true);
        await dispatch(onDeleteBlockMatch({
            match_id: (notification as Likes).match_id,
            block: (notification as Likes).status_user_id2 === "blocked" ? false : true,
        }))
        dispatch(updateMyNotificationReceived({
            type: "match",
            userMyNotification: {
                ...(notification as Likes),
                status_user_id2: (notification as Likes).status_user_id2 === "blocked" ? "match" : "blocked",
            }
        }));
        setIsLikedSwiped(false);
        setLoading(false);
        setContinueBlocked(false);
    }

    return (
        <>
            <div
                className={`relative w-full mb-3 ${(isClicked && isMoving) ? "cursor-grab": "cursor-pointer"} select-none`}
                style={{ touchAction: "pan-y" }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                onTouchCancel={handleTouchEnd}
                onMouseDown={handleMouseDown}
                onMouseMove={isClicked ? handleMouseMove : undefined}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
                onClick={() => { if (!(isLikedSwiped || isSwiped ) && !isMoving) { showInfoProfile((notification as Likes).user_id) }}}
            >
                <div className={`transition-transform duration-300 ease-out ${isSwiped ? '-translate-x-20' : (isLikedSwiped ? 'translate-x-20' : 'translate-x-0')}`}>
                    <Container className='bg-[#F6F7F9] transition-colors duration-300 ease-in-out hover:bg-grayLight rounded-lg h-auto overflow-hidden px-3 py-5'>
                        <Row>
                            {showProfilePicture && (
                                <RemoteImage
                                    className="w-12 aspect-square flex-shrink-0 object-cover rounded-full hover:opacity-90"
                                    src={(notification as Likes).profile_pictures[0].url || "image/default"}
                                    alt={(notification as Likes).username}
                                    draggable={false}
                                />
                            )}
                            <Column className='px-4 flex-grow' crossAxisAlignment='start' mainAxisAlignment="center">
                                <Row mainAxisAlignment='between' crossAxisAlignment='center' draggable={false}>
                                    <TextComponent variant='h6' className='font-bold select-none'>
                                        {notificationMessage()}
                                    </TextComponent>
                                    {category === "alert" && 
                                        <TextComponent variant='h7' className='text-[#6B6B6B] whitespace-nowrap'>
                                            {formatDate((notification as InfoNotificationAdmin).date_at)}
                                        </TextComponent>
                                    }
                                </Row>
                                {category === "like" && (notification as Likes).message_text && 
                                    <TextComponent variant='h7' className='text-[#6B6B6B] whitespace-nowrap select-none'>
										<span className="text-primary">{(notification as Likes).username}</span> sent you an Instant Message
                                    </TextComponent>
                                }
                                {category === "myLikes" && (notification as Likes).message_text && 
                                    <TextComponent variant='h7' className='text-[#6B6B6B] whitespace-nowrap select-none'>
										You sent <span className="text-primary">{(notification as Likes).username}</span> an Instant Message
                                    </TextComponent>
                                }
                                {category === "alert" && 
                                    <div onClick={toggleExpand} className="cursor-pointer select-none">
                                        <TextComponent
                                            variant='h6'
                                            className={`text-[#6B6B6B] mt-1 whitespace-normal`}
                                        >
                                            <LinkifiedText
                                                text={alertSubtitle}
                                                clampLines={isExpanded ? undefined : 2}
                                            />
                                        </TextComponent>
                                        {shouldShowExpand && (
                                            <TextComponent variant='h6' className="text-[#007BFF] mt-1">
                                                {isExpanded ? 'Read less' : 'Read more'}
                                            </TextComponent>
                                        )}
                                    </div>
                                }
                            </Column>
                        </Row>
                    </Container>
                </div>
                {isSwiped && (
                    <button
                        className={`absolute right-0 top-0 h-full w-20 flex items-center justify-center ${category === "like" ? "bg-black text-white" : "bg-primary text-white"} rounded-lg`}
                        onClick={handleOpenWarning}
                    >
                        {category === "like" ?
                            <XClose2 />
                            :
                            <Delete />
                        }
                    </button>
                )}

                {isLikedSwiped && (
                    <button
                        className={`absolute left-0 top-0 h-full w-20 flex items-center justify-center 
                            ${category !== "like"
                                ? (notification as Likes).status_user_id2 === "blocked"
                                ? "bg-green-600 text-white"
                                : "bg-red-600 text-white"
                                : "bg-primary text-white"
                            } rounded-lg`}
                        onClick={handleOpenWarning}
                    >
                        {category === "like" ? 
                            <Heart />
                            :
                            <>
                                {(notification as Likes).status_user_id2 === "blocked" ? 
                                    <History />
                                    :
                                    <Cancelled />
                                }
                            </>
                        }
                    </button>
                )}
            </div>
            {actionNotFound && 
                <>
                    {ReactDOM.createPortal(
                        <ModalRestricted 
                            action={actionNotFound}
                            userInfoProfile={{ user_id: notification.user_id, username: (notification as Likes).username, match_id: (notification as Likes).match_id }}
                            category={category}
                            setAction={setActionNotFound}
                        />,
                        document.getElementById("root") as HTMLElement
                    )}
                </>
            }
            {continueBlocked &&
                <>
                    {ReactDOM.createPortal(
                        <ModalSimple
                            title="Information"
                            variant="secondary"
                            actionExecuted={continueBlocked}
                            onClose={() => setContinueBlocked(false)}
                            onAction={handleBlockMatch}
                            icon={<WarningBG />}
                            loading={loading}
                        >
                            {(notification as Likes).status_user_id2 === "blocked" ? 
                                <>
                                    Are you sure that you want to resume this chat with <span className="text-primary font-bold">{(notification as Likes).username}</span>?
                                </>
                                    :    
                                <>
                                    Are you sure that you would like to leave this conversation with <span className="text-primary font-bold">{(notification as Likes).username}</span>?
                                </>
                            }
                        </ModalSimple>,
                        document.getElementById("root") as HTMLElement
                    )}
                </>
            }
            <ConfirmationModal
                isOpen={isOpenWarning}
                category={category}
                notification={notification}
                onClose={() => setIsOpenWarning(false)}
                onConfirm={handleSwipeAction}
                isLikedSwiped={isLikedSwiped}
            />
        </>
    );
};
